<template>
  <div :class="$style.inlineselect">
    <button
      v-for="option in options"
      :key="option.value"
      type="button"
      :class="{ [$style.selected]: context._value === option.value }"
      @click="onClick(option.value)"
    >
      <template v-if="option.description">
        <div>
          <div>{{ option.label }}</div>
          <div style="color: var(--neutral-700)">
            {{ option.description }}
          </div>
        </div>
        <span data-i="chevron_right" />
      </template>
      <template v-else>
        <span>{{ option.label }}</span>
        <span data-i="chevron_right" />
      </template>
    </button>
  </div>
</template>

<script setup lang="ts">
import { computed, type PropType } from 'vue';
import type { FormKitFrameworkContext } from '@formkit/core';

type Option = { value: string; label: string; description?: string };

const props = defineProps({
  context: {
    type: Object as PropType<
      FormKitFrameworkContext & { options: Option[] | Record<string, string> }
    >,
    required: true,
  },
});

const onClick = (value: string) => {
  props.context.node.input(value);
};

const options = computed(() => {
  if (Array.isArray(props.context.options)) {
    return props.context.options;
  }
  const opts: Option[] = [];
  for (const [value, label] of Object.entries<string>(props.context.options)) {
    opts.push({ value, label });
  }
  return opts;
});
</script>
<style module>
.inlineselect {
  flex: 1;

  button {
    appearance: none;
    border-radius: 0.2em;
    text-align: left;
    padding: 0.6em;
    background: transparent;
    border: none;
    width: 100%;
    display: flex;
    margin: 0;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    transition: background 0.2s;

    &:hover {
      background: var(--neutral-300);
    }

    &.selected {
      background: var(--amber-600);
    }
  }
}

:global(.formkit-inner):has(.inlineselect) {
  --fk-border-box-shadow: none;
  --fk-border-box-shadow-focus: none;
}
</style>
